import { createGlobalStyle } from 'styled-components';
import PoppinsLight from '../../assets/fonts/Poppins-Light.ttf';
import PoppinsRegular from '../../assets/fonts/Poppins-Regular.ttf';
import PoppinsMedium from '../../assets/fonts/Poppins-Medium.ttf';
import PoppinsSemibold from '../../assets/fonts/Poppins-SemiBold.ttf';
import PoppinsBold from '../../assets/fonts/Poppins-Bold.ttf';

const GlobalFont = createGlobalStyle`
    @font-face {
        font-family: 'Poppins-Light';
        src: local('Poppins-Light'), url(${PoppinsLight}) format('truetype');
        font-weight: "Light";
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins-Regular';
        src: local('Poppins-Regular'), url(${PoppinsRegular}) format('truetype');
        font-weight: "Regular";
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins-Medium';
        src: local('Poppins-Medium'),
        url(${PoppinsMedium}) format('truetype');
        font-weight: "Medium";
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins-Semibold';
        src: local('Poppins-Semibols'),
        url(${PoppinsSemibold}) format('truetype');
        font-weight: "Semibold";
        font-style: normal;
    }

    @font-face {
        font-family: 'Poppins-Bold';
        src: local('Poppins-Bold'),
        url(${PoppinsBold}) format('truetype');
        font-weight: "Bold";
        font-style: normal;
    }
`;

export default GlobalFont;
